import { Pipe, PipeTransform } from '@angular/core';
import { AddressbookRecordNumber } from '../../core/services';
import { extractNationalPart } from '../utils/phone.utils';

@Pipe({ name: 'matchingNumbersCount' })
export class MatchingNumbersCountPipe implements PipeTransform {

  public transform(numbers: AddressbookRecordNumber[], defaultNumber: string, search: string, countryPhoneCode?: string): number {
    if (!search || !numbers) return 0;
    return numbers.filter(n =>
      n.number &&
      n.number !== defaultNumber &&
      this.matches(n.number, search, countryPhoneCode)
    ).length;
  }

  private matches(number: string, search: string, countryPhoneCode?: string): boolean {
    if (number.toLowerCase().includes(search.toLowerCase())) return true;
    if (search.startsWith('+')) {
      const national = extractNationalPart(search, countryPhoneCode);
      if (national && number.toLowerCase().includes(national.toLowerCase())) return true;
    }
    return false;
  }

}